import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({
  name: 'propertyFormatter',
})
export class PropertyFormatterPipe implements PipeTransform {
  private predefinedPhrases: string[] = ['Additional Capacity (lbs)', 'Incremental Throughput (lbs/shift)', 'Total Line Shifts'];

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value || !this.predefinedPhrases.includes(value)) {
      return value; // Return the original value if not in the predefined list
    }

    const words = value.split(' ');
    const firstWord = `<span class="font-bold text-[#2E2E38 ]">${words[0]}</span>`;
    const restOfPhrase = words.slice(1).join(' ');

    const formattedPhrase = `${firstWord} ${restOfPhrase}`;
    return this.sanitizer.bypassSecurityTrustHtml(formattedPhrase);
  }
}
